// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
}

/* Custom scrollbar - subtle for operational UI */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background: rgba(15, 23, 42, 0.15);
  border-radius: 0;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(15, 23, 42, 0.3);
}
::-webkit-scrollbar-track {
  background: transparent;
}

/* High-contrast text selection */
::selection {
  background: #0f172a;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".App {\n  min-height: 100vh;\n}\n\n/* Custom scrollbar - subtle for operational UI */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n::-webkit-scrollbar-thumb {\n  background: rgba(15, 23, 42, 0.15);\n  border-radius: 0;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(15, 23, 42, 0.3);\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* High-contrast text selection */\n::selection {\n  background: #0f172a;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
